import React from 'react';
import PropTypes from 'prop-types';

import PricingCategoryHierarchyGreenScreenSettings from './PricingCategoryHierarchyGreenScreenSettings';
import withModal from '../modal/withModal';

export const PRICING_CATEGORY_HIERARCHY_GREEN_SCREEN_SETTINGS_MODAL =
  'MODAL/PRICING_CATEGORY_HIERARCHY_GREEN_SCREEN_SETTINGS';

const propTypes = {
  actionProps: PropTypes.shape({
    albumFolderId: PropTypes.string,
    onSuccess: PropTypes.func,
  }),
};

const PricingCategoryHierarchyGreenScreenSettingsModal = ({
  actionProps,
  ...props
}) => {
  const { albumFolderId, onSuccess } = actionProps ?? {};

  return (
    <PricingCategoryHierarchyGreenScreenSettings
      {...props}
      albumFolderId={albumFolderId ?? props?.albumFolderId}
      onSuccess={onSuccess ?? props?.onSuccess}
    />
  );
};

PricingCategoryHierarchyGreenScreenSettingsModal.propTypes = propTypes;

export default withModal(PricingCategoryHierarchyGreenScreenSettingsModal, {
  name: PRICING_CATEGORY_HIERARCHY_GREEN_SCREEN_SETTINGS_MODAL,
  size: 'xl',
  type: 'full',
  hideHeader: true,
  dismissible: false,
  closeOnOverlayClick: false,
});
